import type { SVGProps } from 'react';
const DawnFlagES = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-ES_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-ES_svg__a)">
      <path
        fill="#DD172C"
        fillRule="evenodd"
        d="M0 4.267h22V0H0zM0 16h22v-4.267H0z"
        clipRule="evenodd"
      />
      <path
        fill="#FFD133"
        fillRule="evenodd"
        d="M0 11.733h22V4.267H0z"
        clipRule="evenodd"
      />
      <path
        fill="#FFEDB1"
        fillRule="evenodd"
        d="M5.762 7.467h1.047V8H5.762z"
        clipRule="evenodd"
      />
      <path
        stroke="#A41517"
        strokeWidth={0.667}
        d="M5.176 7.267h1.172c.195 0 .348.166.332.36l-.117 1.435a.804.804 0 0 1-1.602 0l-.118-1.435a.333.333 0 0 1 .333-.36Z"
      />
      <path
        fill="#A41517"
        fillRule="evenodd"
        d="M4.714 8h2.095v.533h-.524L5.761 9.6l-.523-1.067h-.524z"
        clipRule="evenodd"
      />
      <rect width={1.048} height={3.733} x={3.143} y={6.4} fill="#A41517" rx={0.524} />
      <rect width={1.048} height={3.733} x={7.333} y={6.4} fill="#A41517" rx={0.524} />
      <path
        fill="#A41517"
        d="M4.714 6.187c0-.472.382-.854.853-.854h.389c.471 0 .853.382.853.854a.213.213 0 0 1-.213.213H4.927a.213.213 0 0 1-.213-.213"
      />
    </g>
  </svg>
);
export default DawnFlagES;
